import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Stack from 'react-bootstrap/Stack'
import AddToCart from '../components/add-to-cart'
import ESW_CLASSNAMES from '../esw/classnames'
import TryItFree from '../components/try-it-free'
import Price from '../components/price'
import PriceStriked from '../components/price-striked'
import PercentageOff from '../components/percentage-off'
import useGetPrice from '../hooks/useGetPrice'
import ImageAndThumbnails from './image-and-thumbnails'
import Testimonial from './testimonial'
import Breadcrumbs from './breadcrumbs'
import Workswith from './workswith'
import downloadBlack from '../images/svgs/download-icon-black.svg'

export default function PDPHero({ product }) {
    const {
        badge,
        product_name,
        shop_categories,
        description,
        rawHTMLContent,
    } = product

    const { price, baseprice } = useGetPrice(product)
    
    return (
        <Container fluid className='bg-light'>
            <Container>
                <Row className='gap-5'>
                    <Col lg>
                        <Breadcrumbs product={product} />
                        <ImageAndThumbnails product={product} />
                        <Testimonial product={product} />
                    </Col>
                    <Col className='pt-lg-5 mb-5'>
                        {badge && <p className='text-uppercase bg-primary d-inline-block fw-bold px-3 py-1 mb-4'>
                            {badge}
                        </p>}
                        <h1 className='text-uppercase mb-4' style={{ fontSize: 48 }}>
                            {product_name}
                        </h1>
                        <p className='text-uppercase text-muted mb-4' style={{ fontSize: 20 }}>
                            {shop_categories[0]?.name}
                        </p>
                        <div dangerouslySetInnerHTML={{ __html: description }} />
                        {(baseprice?.promotion_price) &&
                            <p className='mb-0 mt-4 d-flex gap-2 align-items-center'>
                                <PriceStriked
                                    product={product}
                                    style={{ fontSize: 18 }}
                                    eswPriceStrikedClassname={ESW_CLASSNAMES.PAGE_PRICE}
                                />
                                <span className='bg-primary py-0 px-2' style={{ fontSize: 16, fontWeight: 800 }}>
                                    -<PercentageOff price={price ? price : baseprice} />%
                                </span>
                                <span className='text-uppercase text-white bg-black py-0 px-2' style={{ fontWeight: 600 }}>
                                    {baseprice?.promotion_name}
                                </span>
                            </p>
                        }
                        <Price
                            product={product}
                            className='d-inline-block mb-4'
                            style={{ fontSize: 32, fontWeight: 800 }}
                            eswPriceClassName={ESW_CLASSNAMES.PAGE_PRICE}
                        />
                        <Stack direction='horizontal' gap={3}>
                            <TryItFree product={product}
                                className='flex-center gap-1 border border-black shadow px-md-5 py-md-2'
                                style={{ fontSize: 18, width: 212, height: 45 }}
                            >
                                <img src={downloadBlack} alt='' />
                                TRY IT FREE
                            </TryItFree>
                            <AddToCart
                                product={product}
                                className='flex-center gap-1 border border-primary bg-primary shadow px-md-5 py-md-2'
                                style={{ fontSize: 18, width: 212, height: 45 }}
                            />
                        </Stack>
                        <Workswith product={product} />
                        {
                            !rawHTMLContent &&
                            <p className='text-end mt-4 mb-0'>
                                <a href='#system-requirements' className='text-black text-uppercase text-decoration-underline fw-medium ff-primary' style={{ fontSize: 14 }}>
                                    VIEW FULL SYSTEM REQUIREMENTS
                                </a>
                            </p>
                        }
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}